<template>
  <div class="animated fadeIn" id="detailInsentifHelpdesk">
      <h3>{{typeTicket}} Ticket By Helpdesk</h3> <br>
      <strong> Employee : {{name}} </strong>
      <table class="table table-bordered">
          <thead>
              <tr>
                  <th>No</th>
                  <th>Ticket ID</th>
                  <th>Customer</th>
                  <th>Category</th>
                  <th>Problem</th>
                  <template  v-if="typedetail == 'Open'">
                      <th>Open Time</th>
                  </template>
                  <template  v-else-if="typedetail == 'Closed'">
                   <th>Solved Time</th>
                  </template>
                  <th>Ticket Double</th>
              </tr>
          </thead>
          <tbody>
              <template v-for="(data, i) in detail">
                  <tr :key="data.ticket">
                      <td>{{i + 1}}</td>
                      <td>
                          <a :href="'https://isx.nusa.net.id/xtts.php?pid=detail&id=' + data.ticket" target="_blank">
                          {{data.ticket}}
                          </a>
                        </td>
                      <td>
                          <a :href="'https://isx.nusa.net.id/customer.php?custId='+ data.customer +'&pid=profile&module=customer'" target="_blank">
                          {{data.customer}}
                          </a>
                        </td>
                      <td>{{data.kategori}}</td>
                      <td>{{data.problem}}</td>
                      <template v-if="typedetail == 'Open'">
                          <td >{{data.open_time}}</td>
                      </template>
                      <template v-else-if="typedetail == 'Closed'">
                          <td >{{data.solved_time}}</td>
                      </template>
                      <td>
                          <template v-if="data.double">
                              <template v-for="double in checkKoma(data.double)">
                                  <span :key="double">
                                     <a :href="'https://isx.nusa.net.id/xtts.php?pid=detail&id=' + double" target="_blank">
                          {{double}}
                          </a> 
                                      </span> &nbsp;
                              </template>
                          </template>
                      </td>
                  </tr>
              </template>
          </tbody>
      </table>
  </div>
</template>
<script>
import {getService} from '../../../services/get.service'
export default {
    data() {
        return {
            detail: [],
            name: '',
            typedetail: '',
        }
    },
    created() {
       this.getDataDetail(this.url)
       this.typedetail = this.typeTicket
    },
    props: {
        url: {
            type: String,
            default: '',
        },
        typeTicket: {
          type: String,
          default: '',
        }
    },
    watch: {
        url () {
            this.getDataDetail(this.url)
        },
        typeTicket () {
           this.typedetail = this.typeTicket 
        }

    },
    methods: {
        getDataDetail (url) {
            this.$store.commit('noLoad', true)
            getService.getDataFromURL(url)
                .then(data => {
                    this.$store.commit('noLoad', false)
                    this.detail = data.data
                    this.name = data.name
                })
        },
        checkKoma(data) {
            if (data) {
                return data.split(',')
            }
            return []
        }
    }
    
}
</script>
